import Vue from 'vue'
import {
  Button,
  Navbar,
  TabItem,
  TabContainer,
  TabContainerItem,
  Cell,
  Header,
  Tabbar,
  Checklist,
  Radio,
  Swipe,
  SwipeItem,
  Field,
  Actionsheet,
  Badge
} from 'mint-ui'
import 'mint-ui/lib/style.css'

Vue.component('mt-button', Button)
Vue.component('mt-navbar', Navbar)
Vue.component('mt-tab-item', TabItem)
Vue.component('mt-tab-container', TabContainer)
Vue.component('mt-tab-container-item', TabContainerItem)
Vue.component('mt-cell', Cell)
Vue.component('mt-header', Header)
Vue.component('mt-tabbar', Tabbar)
Vue.component('mt-checklist', Checklist)
Vue.component('mt-radio', Radio)
Vue.component('mt-swipe', Swipe)
Vue.component('mt-swipe-item', SwipeItem)
Vue.component('mt-field', Field)
Vue.component('mt-actionsheet', Actionsheet)
Vue.component('mt-badge', Badge)



// WEBPACK FOOTER //
// ./src/plugin/mint.js